/* eslint-disable  import/no-named-as-default */
import { FC, useEffect } from 'react';
import { init as initSaola } from '@saola.ai/browser';
import { Provider } from 'react-redux';
import store from '@redux/store';
import { translate } from 'translations';
import { initializeGainsightWithScript, mixpanelInit } from 'utils';
import { CommonComponentsProvider, StyleProvider, LearningPanelComponents } from 'learning-panel-components';
import 'learning-panel-components/src/styles/fonts/fonts.scss';
import IntlProvider from '@services/translations/intlProvider';
import FullMessageErrorContainer from '@components/snackbarContainer';
import NetworkErrorsContainer from '@components/networkErrorsContainer';
import InnerRoutes from '@routes/innerRoutes';
import './styles/app.scss';
import notAllowedToSolaTenants from 'utils/notAllowedToSolaTenants';

const App: FC = () => {
    useEffect(() => {
        const tenantName = window.location.host.split('.')[0];
        process.env.CB_USE_MIXPANEL == 'true' && initializeGainsightWithScript();
        process.env.CB_USE_MIXPANEL == 'true' && mixpanelInit();
        !notAllowedToSolaTenants.includes(tenantName) && initSaola('0c6656be-6f15-4ece-b67d-6abbdfd9c0a8');
    }, []);

    return (
        <Provider store={store}>
            <IntlProvider>
                <CommonComponentsProvider translate={translate}>
                    <LearningPanelComponents translate={translate}>
                        <StyleProvider>
                            <FullMessageErrorContainer />
                            <InnerRoutes />
                            <NetworkErrorsContainer />
                        </StyleProvider>
                    </LearningPanelComponents>
                </CommonComponentsProvider>
            </IntlProvider>
        </Provider>
    );
};

export default App;
